import API, { OFFERS_API } from "../../Api";
import axios from "axios";
import { Cart, CartRecommendationsRequest, RecClickRequest, RecConvertRequest } from "./cartModels";
import { encryptJson } from "../../utils/react-ec-utils";
import { getCookie } from "../../../helper/cookieHelper";
import { USER_ID } from "../../constants";
import { createRequest } from "../../utils/hmac-utils";

function buildRedeemPayload(cartData: Cart) {
  // A Pay-by-Link payload already contains the redemption selected at the
  // merchant. It is not available in the customer's browser storage, so do
  // not replace it with the normal online-cart fallback below.
  const payByLinkRedeemPayload = (cartData as any).isPayByLinkOrder
    ? (cartData as any).redeemPayload
    : undefined;
  if (
    payByLinkRedeemPayload &&
    typeof payByLinkRedeemPayload === "object" &&
    !Array.isArray(payByLinkRedeemPayload)
  ) {
    return payByLinkRedeemPayload;
  }

  const resolvedRewardIds = (() => {
    if (cartData.redeemIds?.length) {
      return cartData.redeemIds;
    }
    try {
      const raw = localStorage.getItem("pendingLoyaltyRewards");
      if (!raw) return undefined;
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed?.rewardIds) && parsed.rewardIds.length > 0
        ? parsed.rewardIds
        : undefined;
    } catch {
      return undefined;
    }
  })();

  const resolvedPointsToRedeem = (() => {
    try {
      const raw = localStorage.getItem("pendingLoyaltyRewards");
      if (!raw) return undefined;
      const parsed = JSON.parse(raw);
      return typeof parsed?.pointsToRedeem === "number" ? parsed.pointsToRedeem : undefined;
    } catch {
      return undefined;
    }
  })();

  const isOfflinePayment = Boolean((cartData as any).isOfflinePayment);

  return {
    channel: "online",
    reward_ids: resolvedRewardIds ?? [],
    ...(resolvedPointsToRedeem !== undefined && { points_to_redeem: resolvedPointsToRedeem }),
    untraceable: !isOfflinePayment,
  };
}

export async function placeOnlineOrder(cartData: Cart) {
  const userID = getCookie(USER_ID);

  const requestPayload = {
    ...cartData,
    customerId: cartData?.tableId ? "" : userID,
    isCustomerOrder: cartData?.tableId ? false : true,
    redeemPayload: buildRedeemPayload(cartData),
  };

  delete (requestPayload as any).redeemIds;
  delete (requestPayload as any).isOfflinePayment;

  const data = encryptJson(requestPayload);
  const url = requestPayload?.tableId
    ? "/api/customers/order/createOrder/dine-in"
    : "/api/customers/order/createOrder";
  const requestData = requestPayload?.tableId ? { data } : await createRequest(requestPayload);

  return API({
    method: "post",
    url,
    data: requestData,
  });
}

export function placeDineInOrder(cartData: Cart) {
  const requestPayload = {
    ...cartData,
    redeemPayload: buildRedeemPayload(cartData),
  };

  delete (requestPayload as any).redeemIds;
  delete (requestPayload as any).isOfflinePayment;

  const data = encryptJson(requestPayload);

  return API({
    method: "post",
    url: "/api/customers/order/createOrder/dine-in",
    data: { data: data },
  });
}

export function cartItem(data: any){
    return API({
        method: "post",
        url: "/api/customers/order/cartItems",
        data: data
    })
}

export function getCustomerOffers(params: { locationId: string }) {
    return OFFERS_API({
        method: "get",
        url: `/api/v1/offers/customer?locationId=${params.locationId}`,
    })
}
export function validateBogoItem(params: { itemId: string; locationId: string; customerId: string }) {
    return API({
        method: "post",
        url: "/order/validate-bogo-item",
        params,
    })
}
const AIApi = axios.create({
  baseURL: process.env.REACT_APP_AI_ENDPOINT,
  headers: { "Content-Type": "application/json" },
});

export function fetchCartRecommendationsApi(payload: CartRecommendationsRequest) {
  return AIApi.post("/recommendations/cart", payload);
}

export function recClickApi(payload: RecClickRequest) {
  return AIApi.post("/rec/click", payload);
}

export function recConvertApi(payload: RecConvertRequest) {
  return AIApi.post("/rec/convert", payload);
}

